export default __webpack_public_path__ + "static/media/company-not-found.c084da87.svg";